import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { BaseResponse } from '../../responses/BaseResponse';
import { ContactRequest } from '../../requests/ContactRequest';
import { SubscribeRequest } from '../../requests/SubscribeRequest';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  baseUrl = environment.baseUrl;

  constructor(public _http: HttpClient) {
  }

  getHeaders() {
    var requestHeaders = new HttpHeaders();
    requestHeaders.append('Content-Type', 'application/json');
    return requestHeaders;
  }

  /**
  * Author : Sasi Rekha Andru
  * Description :   To insert the Contact-service
  * 
  * */
  public insertContact(contactRequest: ContactRequest): Observable<BaseResponse> {
    const headerDirect = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    return this._http.post<BaseResponse>(this.baseUrl + 'web/new-contact', contactRequest, { headers: headerDirect }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  public subscribeEmail(subscribeRequest: SubscribeRequest): Observable<BaseResponse> {   
    const headerDirect = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    return this._http.post<BaseResponse>(this.baseUrl + 'web/subscribe', subscribeRequest, { headers: headerDirect }).pipe(
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
}
